export default __webpack_public_path__ + "static/media/preview.2b561658.gif";